import anime from 'animejs'

import {Component} from 'lowkey-component'

export class HoverContent extends Component {
  private triggers: Component[] = []
  private contents: Component[] = []

  didMount() {
    const triggers = [...this.element.querySelectorAll('.l-hover-content_trigger')] as HTMLDivElement[]
    this.triggers = triggers.map(trigger => {
      const triggerComponent = new Component(trigger)
      triggerComponent.mount()
      return triggerComponent
    })

    const contents = [...this.element.querySelectorAll('.l-hover-content_content')] as HTMLDivElement[]
    this.contents = contents.map(trigger => {
      const component = new Component(trigger)
      component.mount()
      return component
    })

    this.triggers.map(trigger => {
      trigger.on('mouseenter', (e) => {
        const index = e.target.dataset['index']
        this.contents.map((content, i) => {
          if (i === index-1) {
            if (content.element) {
              content.element.style.visibility = 'visible'
            }
            anime({
              easing: 'easeOutCubic',
              opacity: 1,
              targets: content.element,
            })
          } else {
            if (content.element) {
              content.element.style.visibility = 'hidden'
            }
            anime({
              easing: 'easeOutCubic',
              opacity: 0,
              targets: content.element,
            })
          }
        })
      })
    })

    this.on('mouseleave', () => {
      this.contents.map(content => {
        anime({
          complete: () => {
            if (content.element) {
              content.element.style.visibility = 'hidden'
            }
          },
          easing: 'easeOutCubic',
          opacity: 0,
          targets: content.element,
        })
      })
    })
  }

  didUnmount() {
    this.triggers.map((comp) => {
      comp.destroy()
    })
    this.contents.map((comp) => {
      comp.destroy()
    })
  }
}
